import { differenceInYears } from 'date-fns';

export function calculateAge(
  dateOfBirth: string | number,
  date: string | number = Date.now(),
) {
  const age = differenceInYears(date, dateOfBirth);
  return age;
}
